/**
 * Gardes de route.
 *
 * `ProtectionRoute` exige une session ouverte ; `ProtectionCapacite` exige en plus une capacité.
 * Ce sont des gardes d'ERGONOMIE : elles évitent d'afficher un écran vide et un 403, elles ne
 * protègent rien. La donnée n'arrive que si le serveur l'autorise.
 */

import type { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';

import { EtatVide } from '../components/EtatVide';
import { motifIndisponibilite, type Capacite } from './permissions';
import { useOperateur, usePeut } from './useSession';

export function ProtectionRoute({ children }: { children: ReactNode }): JSX.Element {
  const operateur = useOperateur();
  const emplacement = useLocation();

  if (!operateur) {
    // `de` permet de revenir à l'écran demandé après la connexion.
    return <Navigate to="/connexion" replace state={{ de: emplacement.pathname + emplacement.search }} />;
  }

  return <>{children}</>;
}

export function ProtectionCapacite({
  capacite,
  children,
}: {
  capacite: Capacite;
  children: ReactNode;
}): JSX.Element {
  const operateur = useOperateur();
  const autorise = usePeut(capacite);

  if (!autorise) {
    return (
      <EtatVide
        titre="Accès non autorisé"
        description={motifIndisponibilite(operateur)}
      />
    );
  }

  return <>{children}</>;
}
